﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListMail extends GuiListGeneric {

    constructor() {
        super("Mail");

    }

    protected clickRow() {
        this.log("clickRow");
    }
}
